import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';

class StudentAdvisor{


    Student_Advisor_Data(StudentID){
        return axios.post(API_URL+`AcademicAdvising/Student_Advisor_Data?StudentID=${StudentID}`,
       
        {  headers: authHeader() })
    }

    Student_Allowed_Forbidden_Courses_get(StudentID){
        return axios.post(API_URL+`AcademicAdvising/Student_Advisor_Allowed_Forbidden_Courses_get?StudentID=${StudentID}`,
       
        {  headers: authHeader() })
    }
    StudentAdvisingStatus(StudentID){
        return axios.get(API_URL+`AcademicAdvising/StudentAdvisingStatus?StudentID=${StudentID}`,
       
        {  headers: authHeader() })
    }

    StudentRequestCoursesSelect(StudentID, CourseCode, CourseName){
        return axios.get(API_URL+`AcademicAdvising/student_RequestCourses_Select?StudentID=${StudentID}&CourseCode=${CourseCode}&CourseName=${CourseName}`,
       
        {  headers: authHeader() })
    }

    StudentInsertRequestCourse(StudentID, CrsID){
        return axios.get(API_URL+`AcademicAdvising/Student_insert_RequestCourse?StudentID=${StudentID}&CrsID=${CrsID}`,
       
        {  headers: authHeader() })
    }

}

export default new StudentAdvisor();